import React from 'react'
import { addPayment } from 'client/utils/api-routes-invoice'
import _ from 'lodash'
import moment from 'moment'
import {
  DcButton,
  DcDropDown,
  DcInput,
  DcText,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelText,
} from 'pixel-base'
import styled from 'styled-components'

import { getPaymentHeads } from 'utils/api-routes.util'
import { IPixelFactory } from 'client/../decl'

const PaymentRecord = (props) => {
  const { invoiceId, handleClose } = props
  const { showSuccess, showPageLoader, hidePageLoader } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [error, setError] = React.useState({ error: '', field: '' })
  const [bankHeads, setBankHeads] = React.useState({})
  const [incomeHeads, setIncomeHeads] = React.useState({})

  const [data, setData] = React.useState({
    date: moment().format('YYYY-MM-DD'),
    amount: '',
    income_head_id: '',
    bank_head_id: '',
    payment_method_type: '',
    comments: '',
  })
  const [Methods, setMethods] = React.useState([])

  const paymentHeads = () => {
    getPaymentHeads().subscribe((res) => {
      const dataIs = res.response?.data
      setBankHeads(_.groupBy(dataIs?.bank_heads, 'classification.title'))
      setIncomeHeads(_.groupBy(dataIs?.income_heads, 'classification.title'))
    })
  }

  const handelSubmit = (e) => {
    e.preventDefault()
    showPageLoader()
    addPayment(invoiceId, data).subscribe((res) => {
      hidePageLoader()
      if (res.response?.error) {
        setError({ error: res.response?.error, field: res.response?.field })
      } else {
        showSuccess('Payment Record Successfully Added')
        setData(res.response?.data)
        handleClose(res?.response?.data)
      }
    })
  }

  const formatOptions = (data) => {
    const options = {
      ...data,
    }
    Object.keys(options).map((key) => {
      return options[key].map((item) => {
        item.value = Number(item.id)
        item.label = item.account_name

        return item
      })
    })
    return options
  }

  const Method = [
    { label: 'Select Payment Method', value: '' },
    ...Methods.map((item) => ({ label: item.name, value: item.id })),
  ]

  React.useEffect(() => {
    setMethods(props.options[0])
    paymentHeads()
  }, [])

  return (
    <Form onSubmit={handelSubmit}>
      <PixelFlexBox gap="10px" flexDirection="column">
        <PixelText>
          {`Record a payment you've already received , such as cash, check, or
          bank payment`}
        </PixelText>
        <PixelFlexBox>
          <PixelDiv style={{ width: '100%' }}>
            <DcText>Date</DcText>
            <DcInput
              as="datePicker"
              isShowLabel={true}
              placeholder="Date"
              value={
                data.date
                  ? moment(data.date).format('YYYY-MM-DD 19:14:SS.SSSSSS')
                  : null
              }
              onChange={(selectedDate) => {
                setData({
                  ...data,
                  date: moment(selectedDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
                })
              }}
              name={'Date'}
            />
          </PixelDiv>
        </PixelFlexBox>
        <PixelFlexBox>
          <DcInput
            error={
              error.field === 'amount' && error.error !== ''
                ? error.error
                : null
            }
            type="number"
            placeholder="Amount"
            name="Amount"
            value={data.amount}
            onChange={(e) => {
              setData({ ...data, amount: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <DcDropDown
            isgrouped={true}
            placeholder={'Categorize Sales'}
            customLabel={'Categorize Sales'}
            error={
              error.field === 'account_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            groupOptionData={formatOptions(incomeHeads)}
            value={data.income_head_id}
            onChange={(e) => {
              setData({ ...data, income_head_id: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <DcDropDown
            isgrouped={true}
            placeholder={'Receiving Account'}
            customLabel={'Receiving Account'}
            error={
              error.field === 'account_name' && error.error !== ''
                ? error.error
                : null
            }
            required
            groupOptionData={formatOptions(bankHeads)}
            value={data.bank_head_id}
            onChange={(e) => {
              setData({ ...data, bank_head_id: e.target.value })
            }}
          />
        </PixelFlexBox>
        <PixelFlexBox>
          <DcDropDown
            error={
              error.field === 'payment_method_type' && error.error !== ''
                ? error.error
                : null
            }
            required
            options={Method}
            value={data.payment_method_type}
            onChange={(e) => {
              setData({ ...data, payment_method_type: e.target.value })
            }}
            placeholder={'Payment Method'}
          />
        </PixelFlexBox>

        <PixelFlexBox>
          <DcInput
            error={
              error.field === 'note' && error.error !== '' ? error.error : null
            }
            as="textarea"
            placeholder="Note"
            name="Note"
            value={data.comments}
            onChange={(e) => {
              setData({ ...data, comments: e.target.value })
            }}
          />
        </PixelFlexBox>
      </PixelFlexBox>
      <PixelFlexBox gap="10px" justifyContent="flex-end">
        <DcButton variant="outline-secondary" onClick={handleClose}>
          Close
        </DcButton>
        <DcButton type="submit" variant="primary">
          Add
        </DcButton>
      </PixelFlexBox>
    </Form>
  )
}

const Form = styled.form<{ gap?: boolean }>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: ${(props) => (props.gap ? '0' : '10px')};
`

export default PaymentRecord
